{
  "DATA_ASSISTANT": {
    "TITLE": "Trợ lý Dữ liệu",
    "NEW_CONVERSATION": "+ Mới",
    "LOADING": "Đang tải...",
    "LOADING_MESSAGES": "Đang tải tin nhắn...",
    "THINKING": "Đang suy nghĩ...",
    "UNTITLED": "Cuộc trò chuyện chưa đặt tên",
    "NO_CONVERSATIONS": "Chưa có cuộc trò chuyện nào. Nhấp vào \"+ Mới\" để bắt đầu.",
    "EMPTY_STATE": "Chọn một cuộc trò chuyện hoặc tạo mới để bắt đầu.",
    "PLACEHOLDER": "Tôi có thể tìm gì giúp bạn?",
    "SHOW_SQL": "Hiện SQL",
    "NO_ROWS": "Không có dòng nào được trả về.",
    "DELETE": "×",
    "DELETE_CONFIRM": "Xoá cuộc trò chuyện",
    "DELETE_CONFIRM_DESCRIPTION": "Bạn có chắc chắn muốn xoá cuộc trò chuyện này không? Hành động này không thể hoàn tác.",
    "DELETE_CONFIRM_YES": "Xoá",
    "REPORTS": "Báo cáo",
    "SAVE_TO_REPORT": "Lưu vào báo cáo",
    "NEW_REPORT": "Báo cáo mới",
    "REPORT_NAME": "Tên báo cáo",
    "NO_REPORTS": "Chưa có báo cáo nào được lưu",
    "REPORTS_EMPTY_STATE": "Chọn một báo cáo hoặc tạo mới.",
    "REPORT_SAVED": "Đã lưu vào báo cáo",
    "DELETE_REPORT_CONFIRM": "Xoá báo cáo",
    "DELETE_REPORT_CONFIRM_DESCRIPTION": "Bạn có chắc chắn muốn xoá báo cáo này không? Tất cả các mục đã lưu sẽ bị xoá.",
    "DELETE_ITEM_CONFIRM": "Xoá mục",
    "DELETE_ITEM_CONFIRM_DESCRIPTION": "Bạn có chắc chắn muốn xoá mục này khỏi báo cáo không?",
    "EXPORT_CSV": "Xuất CSV",
    "REFRESH": "Làm mới",
    "QUERY_RUNNING": "Đang chạy truy vấn...",
    "QUERY_FAILED": "Truy vấn thất bại",
    "AUTO_REFRESH": "Tự động làm mới",
    "AUTO_REFRESH_NONE": "Thủ công",
    "AUTO_REFRESH_30S": "30 giây",
    "AUTO_REFRESH_1M": "1 phút",
    "AUTO_REFRESH_5M": "5 phút",
    "AUTO_REFRESH_10M": "10 phút",
    "EDIT_MESSAGE": "Chỉnh sửa tin nhắn",
    "RENAME_REPORT": "Đổi tên báo cáo",
    "RENAME_ITEM": "Đổi tên mục",
    "MOVE_UP": "Di chuyển lên",
    "MOVE_DOWN": "Di chuyển xuống",
    "COLLABORATORS": {
      "BUTTON": "Cộng tác viên",
      "TITLE": "Cộng tác viên của báo cáo",
      "DESCRIPTION": "Chọn nhân viên và nhóm nào có thể xem báo cáo này.",
      "AGENTS": "Nhân viên",
      "TEAMS": "Nhóm",
      "SELECT_AGENTS": "Chọn nhân viên",
      "SELECT_TEAMS": "Chọn nhóm",
      "SAVE": "Lưu",
      "SAVED": "Đã cập nhật cộng tác viên",
      "SAVE_FAILED": "Không thể cập nhật cộng tác viên"
    }
  }
}
